import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'virtual:svg-icons-register';
import 'virtual:uno.css';
import App from './App.tsx';
import './i18n';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
